class Notes extends Events
{
  constructor ()
  {
    super();

    this.data = null;
    this.currentFetch = null;
  }

  init ()
  {
    this.getNotes().then(data => {
      broadcast('notes', data);
    });
  }

  update (productId, note)
  {
    return new Promise((resolve, reject) => {
      const fullProductId = 'gid://shopify/Product/' + productId;

      fetch('https://app.donornetwork.com/api/shopify/customer/notes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...app.apiHeaders()
        },
        body: JSON.stringify({
          product_id: fullProductId,
          note: note
        })
      }).then(res => res.json())
        .then(data => {
          if (!data || !data.success) {
            console.error('Failed to edit note:', data);
            reject(null);
          } else {
            // API returns { success: true }, so update local data optimistically
            if (!this.data) {
              this.data = [];
            }

            // Find existing note for this product
            const existingIndex = this.data.findIndex(n => n.product_id === fullProductId);

            if (note && note.trim() !== '') {
              // Add or update note
              if (existingIndex >= 0) {
                this.data[existingIndex].note = note;
              } else {
                this.data.push({ product_id: fullProductId, note: note });
              }
            } else {
              // Delete note (empty string or null)
              if (existingIndex >= 0) {
                this.data.splice(existingIndex, 1);
              }
            }

            app.cache.put(window.cacheKeys.notes, this.data, 86400);

            broadcast('notes', this.data);

            resolve(this.data);
          }
        })
        .catch(error => reject(error));
    });
  }

  async hasNote (productId)
  {
    const notes = await this.getNotes();

    if (!notes) {
      return false;
    }

    let hasNote = false;
    const currentProductId = "gid://shopify/Product/" + productId;

    notes.forEach(note => {
      if (note.product_id == currentProductId) {
        hasNote = true;
      }
    });

    return hasNote;
  }

  getNotes ()
  {
    return new Promise((resolve, reject) => {
      if (this.data) {
        resolve(this.data);
        return;
      }

      const data = app.cache.get(window.cacheKeys.notes);

      if (data) {
        this.data = data;
        resolve(this.data);
        return;
      }

      this.fetch().then(data => {
        resolve(data);

        return data;
      });
    });
  }

  getNoteByProductId (productId)
  {
    return new Promise((resolve, reject) => {
      this.getNotes()
        .then(notes => resolve(notes.find(note => note.product_id.split('/')[4] == productId)))
        .catch(err => reject(err));
    });
  }

  fetch ()
  {
    if (!this.currentFetch) {
      this.currentFetch = new Promise((resolve, reject) => {
        fetch('https://app.donornetwork.com/api/shopify/customer/notes', {
          headers: {
            'Content-Type': 'application/json',
            ...app.apiHeaders()
          }
        }).then(res => res.json())
          .then(res => {
            this.data = res.data;

            app.cache.put(window.cacheKeys.notes, this.data, 86400);

            this.currentFetch = null;

            resolve(this.data);
          });
      });
    }

    return this.currentFetch;
  }
}